import React from "react";
import { useTranslation } from "react-i18next";
import CardSlider from "../Slider/Slider";
import HeaderSliderCard from "../HeaderSlider/HeaderSliderCard/HeaderSliderCard";
import styles from "./HeaderSlider.module.scss";

interface SliderImage {
  src1920: string;
  src1440: string;
  src768: string;
  src320: string;
  alt: string;
  imageType?: "full" | "partial";
  className?: string;
  title?: string;
  description?: string;
  isH1?: boolean;
}

interface HeaderSliderProps {
  images: SliderImage[];
}

const HeaderSlider: React.FC<HeaderSliderProps> = ({ images }) => {
  const { t } = useTranslation("common");

  const sliderSettings = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
      prevEl: `.${styles.customPrev}`,
      nextEl: `.${styles.customNext}`,
    },
    pagination: {
      clickable: true,
      el: `.${styles.swiperPagination}`,
    },
  };

  return (
    <div className={styles.sliderWrapper}>
      <CardSlider settings={sliderSettings}>
        {images.map((image) => (
          <HeaderSliderCard
            key={image.src1920}
            imageSrc1920={image.src1920}
            imageSrc1440={image.src1440}
            imageSrc768={image.src768}
            imageSrc320={image.src320}
            alt={image.alt}
            imageType={image.imageType || "full"}
            className={image.className}
            title={image.title}
            description={image.description}
            isH1={image.isH1}
          />
        ))}
      </CardSlider>

      <div className={styles.navigationWrapper}>
        <button
          className={styles.customPrev}
          aria-label={t("common.previous") || "Previous slide"}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            fill="none"
            aria-hidden="true"
          >
            <path
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13.31 4 3 14l10.31 10M8.552 14H25"
            />
          </svg>
        </button>

        <div className={styles.swiperPagination}></div>

        <button
          className={styles.customNext}
          aria-label={t("common.next") || "Next slide"}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            fill="none"
            aria-hidden="true"
          >
            <path
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M14.69 4 25 14 14.69 24m4.758-10H3"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default HeaderSlider;
